import CavesServices from "./CavesServices.js";

export default {
  getAuthorizationToken() {
    var tokenRequest = {
      UserName: process.env.VUE_APP_USERNAME,
      Password: process.env.VUE_APP_PASSWORD
    };
    return CavesServices.getEndpointForCreateToken("Login", tokenRequest);
  }
};
